import { Col, Form, Input, Row } from "antd";
import { PhoneInput } from "@/shared/components/PhoneInput";
import { useUsersStore } from "../store/users.store";

export function UserForm() {
	const editingUser = useUsersStore((s) => s.editingUser);

	return (
		<>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item
						name="fullname"
						label="To'liq ism"
						rules={[{ required: true, message: "Ismni kiriting" }]}
					>
						<Input placeholder="Abdullayev Sardor" id="user-fullname" />
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="phone"
						label="Telefon raqam"
						rules={[
							{ required: true, message: "Telefon raqamni kiriting" },
							{ pattern: /^\+998\d{9}$/, message: "To'liq 9 ta raqam kiriting" },
						]}
					>
						<PhoneInput id="user-phone" />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item
						name="password"
						label={editingUser ? "Yangi parol (ixtiyoriy)" : "Parol"}
						rules={
							editingUser
								? []
								: [
										{ required: true, message: "Parolni kiriting" },
										{ min: 4, message: "Kamida 4 ta belgi" },
									]
						}
					>
						<Input.Password
							placeholder={editingUser ? "O'zgartirmasangiz bo'sh qoldiring" : "Parol"}
							id="user-password"
							autoComplete="new-password"
						/>
					</Form.Item>
				</Col>
			</Row>
		</>
	);
}
